import React from 'react';
import {Accordion, AccordionBody, AccordionHeader, AccordionItem} from "react-headless-accordion";
import "../../assets/css/common/accordion.scss";

const Index = ({title, content}) => {
    return (
        <Accordion>
            <AccordionItem>
                {({open}) => (
                    <>
                        <AccordionHeader
                            className="accordion-header">
                            <p className='title'>{title}</p>
                            <svg
                                className={`arrow-icon ${!open ? 'rotate-0' : 'rotate-90'}`}
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </AccordionHeader>
                        <AccordionBody className="accordion-body-container">
                            <div className="accordion-body">{content}</div>
                        </AccordionBody>
                    </>
                )}
            </AccordionItem>
        </Accordion>
    );
};

export default Index;
